import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
var ReactSuperSelect = require('react-super-select');
const crypto = require('crypto')
const moment = require('moment');

var emptyRecipientObject = {
	id: false,
	phoneNumber: '',
	emailAddress: '',
	sms: false,
	call: false,
	email: false,
	firstName: '',
	lastName: '',
	zipCode: '', 
	stopper: [{
	}]
}

class GTFSSignUp extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			selectedSection: 'SurveySettings',
			addingSetting: false,
			editBox: false,
			addBox: false,
			loading: false,
			filterBy: {},
			configureStopper: {
				routeId: false,
				stopId: false,
				time: '12:00',
				selectedWeekdays: {}
			},
			stopIdList: false,
			selectedStopId: false,
			selectedRouteId: false
		};
	}

	//this returns a list to populate the RouteID dropdown list
	populateRouteIDs() {
		console.log('populateRouteIDs');
		var list = []
		for (let i in this.props.data.GTFSSignUp.routesWithStops) {
			var route = this.props.data.GTFSSignUp.routesWithStops[i]
			var item =  {
				'id': route.route_id,
				'name': route.route_id + ' - ' + route.route_long_name
			}
			list.push(item)
		}

		list.sort(function(a, b) {
			return a.id - b.id
		});

		return list;
	}

	//this returns a list to populate the StopID dropdown list, based on what is selected in the Route ID dropdown list.
	populateStopIDs(id) {
		console.log('populateStopIDs');
		console.log(id);
		var list = []
		console.log(this.props.data.GTFSSignUp.routesWithStops[id])
		for (let i in this.props.data.GTFSSignUp.routesWithStops[id].stops) {
			var stop = this.props.data.GTFSSignUp.routesWithStops[id].stops[i]
			var item =  {
				'id': stop.stop_id,
				'name': stop.stop_id + ' - ' + stop.stop_name
			}
			list.push(item)
		}

		list.sort(function(a, b) {
			return a.id - b.id
		});

		return list;
	}

	//translates this.state.selectedObject.stoppers to table on edit screen.
	populateScheduledAlerts(stoppers) {
		console.log('populateScheduledAlerts');
		console.log(stoppers);
		console.log(this.state.selectedObject);

		var content
		content = [];

		if (Object.keys(stoppers).length) {
			for (var stop in stoppers) {
				for (var d in stoppers[stop].times) { 					//with me so far?
					for (var t in stoppers[stop].times[d]) { 			//trust me. it's gonna be great.
						let routeId = stoppers[stop].routeID;			//let's make sense of everything before we continue
						let stopId = stoppers[stop].stopID;
						let day = d;
						let time = stoppers[stop].times[d][t];

						content.push(
							<div className="dataRow">
								<span style={{ flex: '0 0 15%', textAlign: 'left'}}>{routeId}</span>
								<span style={{ flex: '0 0 15%', textAlign: 'left'}}>{stopId}</span>
								<span style={{ flex: '0 0 25%', textAlign: 'left'}}>{day}</span>
								<span style={{ flex: '0 0 15%', textAlign: 'left'}}>{time}</span>

								<span className="buttonBox" style={{ flex: '0 0 50px' }}>
									<img src={this.props.img.delete} alt="Delete Alert" onClick={() => this.removeScheduledAlert(routeId, stopId, day, time)} />
								</span>
							</div>
						)
					}
				}
			}
		} else {
			content.push(
				<div className="dataRow">
					<span style={{ flex: '0 0 100%', textAlign: 'left'}}>No scheduled alerts to display.</span>
				</div>
			)
		}

		return content;
	}

	//remove alert/stopper from edit screen table
	removeScheduledAlert(routeToRemove, stopToRemove, dayToRemove, timeToRemove) {
		console.log('removeScheduledAlert');
		console.log(this.state.selectedObject)
		var newSetting = Object.assign({}, this.state.selectedObject)
		newSetting.stopper = [];
		
		//for each stop
		for (var s in this.state.selectedObject.stopper) {
			console.log(s);

			for (var d in this.state.selectedObject.stopper[s].times) {
				for (var t in this.state.selectedObject.stopper[s].times[d]) {
					let route = this.state.selectedObject.stopper[s].routeID;
					let stop = this.state.selectedObject.stopper[s].stopID;
					let day = d;
					let time = this.state.selectedObject.stopper[s].times[d][t];

					console.log ('checking ' + route + ', ' + stop + ', ' + day + ', ' + time);

					//recreate the object without the item selected for deletion
					//if anything at all doesn't match what we want to delete...
					if ((routeToRemove != route) || (stopToRemove != stop) || (dayToRemove != day) || (timeToRemove != time)) {

						//object starts blank, so make sure the structure is recreated
						if (!newSetting.stopper[s]) {

							newSetting.stopper[s] = {
								routeID: route,
								stopID: stop,
								times: {}
							}
						}

						if (!newSetting.stopper[s].times[day]) {
							newSetting.stopper[s].times[day] = [];
						}

						newSetting.stopper[s].times[day].push(time);
					}
				}
			}
		}

		//let's get rid of any null values
		var filtered = newSetting.stopper.filter(function (el) {
			return el != null
		})

		newSetting.stopper = filtered;

		this.setState({ selectedObject: newSetting, loading: false })
	}

	changedRouteId = (option) => {
		console.log('changedRouteId');

		var newSetting = Object.assign({}, this.state.configureStopper)

		newSetting.routeId = (option ? option.id : false )
		
		this.setState({
			stopIdList: this.populateStopIDs(option.id),
			configureStopper: newSetting
		});
	}

	changedStopId = (option) => {
		console.log('changedStopId');

		var newSetting = Object.assign({}, this.state.configureStopper)
		
		newSetting.stopId = (option ? option.id : false )
		
		console.log(newSetting);

		this.setState({
			configureStopper: newSetting
		});
	}

	//save scheduled alert (routeid, stopid, day, time) to selectedObject. Still needs saved to memory when user is done editing.
	addScheduledAlert = (newStopper) => (e) => {
		console.log('addScheduledAlert')
		this.checkState();
		
		//we'll use this to make sure the correct options are filled
		var optionsSelected = false;

		//if ANY day is selected, continue
		for (let day in this.state.configureStopper.selectedWeekdays) {
			if (this.state.configureStopper.selectedWeekdays[day]) {
				optionsSelected = true;
			}
		}

		//if routeId, stopId or time is not selected, can't continue
		if ((!this.state.configureStopper.routeId) || (!this.state.configureStopper.stopId) || (!this.state.configureStopper.time)) {
			optionsSelected = false;
		}

		//can't continue
		if (optionsSelected == false) {
			this.setState({
				errorAddScheduledAlert: 'Please select a route, stop, day and time.'
			})

		//things look good, let's continue 
		} else {

			//var newSetting = Object.assign({}, this.state.selectedObject)
			var newSetting = JSON.parse(JSON.stringify(this.state.selectedObject));

			//for each day selected by the user
			for(let day in this.state.configureStopper.selectedWeekdays) {

				//unselected days leave a 'false' record, so let's make sure not to include them
				if (this.state.configureStopper.selectedWeekdays[day]) {
					console.log(day);

					//check for matches
					var match = false;

					//for each existing stoppper...
					for (let existingStopper of this.state.selectedObject.stopper) {
						//if the route and stop match...
						if((existingStopper.routeID == this.state.configureStopper.routeId) && (existingStopper.stopID === this.state.configureStopper.stopId)) {
							//check each day...
							for(let existingDay in existingStopper.times) {
								//if the day matches...
								if (existingDay == day) {
									//check each hour
									for(let existingTime of existingStopper.times[existingDay]) {
										//if the hour matches...
										if (existingTime == this.state.configureStopper.time) {
											match = true;
											//mark as already exists
										}
									}
								}
							}
						}
					}

					if (match) {
						console.log('already exists, skipping.');
					} else {
						console.log('does not exist. okay to add.');

						
						//since the stopper objects aren't addressable by stop/route/time, we need to see if a matching route/stop exists to edit before creating a fresh one.
						var alreadyFound = false;

						//for each existing stopper...
						for (let i in newSetting.stopper) {
							//if route and stop match...
							if(( newSetting.stopper[i].routeID == this.state.configureStopper.routeId) && (newSetting.stopper[i].stopID === this.state.configureStopper.stopId)) {

								//if there is no existing entry for the day, add it
								console.log(newSetting.stopper[i].times)
								if(!newSetting.stopper[i].times[day]) {
									newSetting.stopper[i].times[day] = []
								}

								//if the specific hour doesn't exist under the day, we'll add it in there.
								if(!newSetting.stopper[i].times[day][this.state.configureStopper.time]) {
									newSetting.stopper[i].times[day].push(this.state.configureStopper.time)
								}

								//we found it or just added it.  either way this becomes true.
								alreadyFound = true;
							}
						}

						//if we didn't find a route/id match already...
						if (!alreadyFound) {
							console.log('not found');
							var timesObject = {};
							timesObject[day] = [this.state.configureStopper.time];

							newSetting.stopper.push (
								{
									routeID: this.state.configureStopper.routeId,
									stopID: this.state.configureStopper.stopId,
									times: timesObject
								}
							)
							
							
						}
					}

				}


				
			}
			
			console.log(newSetting);
			this.checkState();

			this.setState({
				errorAddScheduledAlert: 'Alert(s) added, but changes are not yet saved.',
				selectedObject: newSetting
			})
		}
	}

	checkState = (option) => {
		console.log('state')
		console.log(this.state)
		console.log('recipients:')
		console.log(this.props.data.GTFSSignUp.recipients)
	}

	showEditBox = (type, data) => e => {
		console.log('showEditBox');

		this.setState({
			editBox: type,
			selectedObject: data,
			originalObject: data,
			loading: false
		})
		console.log(this.state);
	}

	showAddBox = (type) => e => {
		var data = emptyRecipientObject;

		data.id = this.newID();

		console.log('newID is ' + data.id);

		this.setState({
			addBox: type,
			setting: {},
			loading: false,
			selectedObject: data,
			originalObject: data
		})
	}

	showDeleteBox = (type, data) => e => {
		console.log('showDeleteBox')
		e.stopPropagation()
		this.setState({ deleteBox: type, selectedObject: data, loading: false })
	}

	editParam = (param) => (e) => {
		console.log('editParam')

		var newSetting = Object.assign({}, this.state.selectedObject)
		newSetting[param] = e.target.value
		this.setState({ selectedObject: newSetting, loading: false })
		
		console.log(this.state);
	}

	toggle = (param) => (e) => {
		console.log('toggle')
		console.log(this.state.selectedObject);
		var newSetting = Object.assign({}, this.state.selectedObject)
		newSetting[param] = this.state.selectedObject[param] ? false : true
		this.setState({ selectedObject: newSetting, loading: false })
	}

	toggleWeekdaySelection = (param) => (e) => {
		console.log('toggleWeekdaySelection')
		console.log('toggling ' + param);
		
		var newSetting = Object.assign({}, this.state.configureStopper)

		if (!newSetting.selectedWeekdays[param]) {
			newSetting.selectedWeekdays[param] = false;
		}

		console.log(newSetting);

		newSetting.selectedWeekdays[param] = newSetting.selectedWeekdays[param] ? false : true
		this.setState({ configureStopper: newSetting, loading: false })
	}

	cancel = () => {
		console.log('cancel');
		this.setState({
			editBox: false,
			addBox: false,
			deleteBox: false,
			addingSetting: false,
			loading: false,
			selectedObject: false,
			originalObject:false,
			error: false,
			errorAddScheduledAlert: false,
			configureStopper: {
				routeId: false,
				stopId: false,
				time: '12:00',
				selectedWeekdays: {}
			},
			stopIdList: false,
			selectedStopId: false,
			selectedRouteId: false
		})

		console.log(this.state);
	}

	toggleSection = (option) => {
		if (option) {
			this.setState({ selectedSection: option.id, error: '' });
		}
	}

	confirmChanges = (data) => (e) => {
		console.log('confirmChanges');
		
		//data validation
		var recipients = this.props.data.GTFSSignUp.recipients
		var errorFound = false;

		if((data.firstName == '') || data.lastName == '') {
			errorFound = true;
			console.log(this.props.img);
			this.setState({error: 'Please enter a first and last name'});
		} else if ((data.phoneNumber.length == 0) && data.emailAddress == '') {
			errorFound = true;
			this.setState({error: 'Please enter a valid phone number or email address'});
		} else if (data.phoneNumber.length > 0 && data.phoneNumber.length != 10) {
			errorFound = true;
			this.setState({error: 'Please make sure phone number is entered as a 10 digit number'});
		} else if ((data.sms || data.call) && data.phoneNumber == '') {
			errorFound = true;
			this.setState({error: 'Please enter a phone number for this method of contact'});
		} else if (data.email && data.emailAddress == '') {
			errorFound = true;
			this.setState({error: 'Please enter an email address for this method of contact'});
		} else {
			for (var i in recipients) {
				let recipient = recipients[i];
				if ((data.phoneNumber.length > 0 ) && (data.phoneNumber == recipient.phoneNumber)) {
					if(data.id != recipient.id) {
						errorFound = true;
						this.setState({error: 'Phone number already exists in another record'});
					}
				}
				else if ((data.emailAddress.length > 0) && (data.emailAddress == recipient.emailAddress)) {
					if(data.id != recipient.id) {
						errorFound = true;
						this.setState({error: 'Email address already exists in another record'});
					}
				}
			}
		}

		console.log ('error found 2: ' + this.state.error);

		if (errorFound == false) {
			console.log('updating recipient list');
			//this.props.data.GTFSSignUp.recipients[data.id] = (data);
			this.props.ws.send(JSON.stringify({ route: 'addGTFSRecipient', setting: data }))
			this.setState({error: false});
			this.cancel();
		}
	}

	confirmDelete = (type, data) => e => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'delete' + type, setting: data }))
	}
	
	filter = (newFilter) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[newFilter] = e.target.value
		} else {
			delete filterBy[newFilter]
		}
		this.setState({ filterBy: filterBy }) //
	}

	sortFunc(sortBy, sortOrder) {
		return function (a, b) {
			if (sortBy === 'dateRange') {
				return new Date(a.StartDateTime).getTime() > new Date(b.StartDateTime).getTime() ? 1 * sortOrder : -1 * sortOrder
			}
			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.ID > b.ID ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			} else if (!(sortBy in a) && !(sortBy in b)) {
				return a.ID > b.ID ? 1 * sortOrder : -1 * sortOrder
			} else {

				return sortBy in a ? -1 : 1
			}
		}
	}

	filterFunc(array, filterBy) {
		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (prop === 'records') {
					if (object.rows.length.toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
						return false
					}
				} else if (prop === 'updatedDate') {
					if ((new Date(object.updatedDate).toDateString().substring(4) + ', ' + new Date(object.updatedDate).toLocaleTimeString()).toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
						return false
					}
				} else if (typeof object[prop] === "undefined") {
					return false
				} else if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true
		})
	}

	newID() {
        var hexstring = crypto.randomBytes(10).toString("hex");
        return [hexstring.substring(0, 19), new Date().getTime().toString()].join('');
    }

	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel();
		}
	}

	render() {
		if (this.props.active) {
			var contentMain, contentEditBox

			contentMain = [];
			contentEditBox = [];
			contentMain.push(<img src={this.props.img.plus} className="plusButton" alt="Add A Recipient" onClick={this.showAddBox('GTFSSignUp')} />);

			contentMain.push(
				<div>
					<div className="dataHeaders">
						<span style={{ flex: '2 2 20%', cursor: 'pointer' }}>Name</span>
						<span style={{ flex: '2 2 15%', cursor: 'pointer' }}>Phone Number</span>
						<span style={{ flex: '2 2 30%', cursor: 'pointer' }}>Email Address</span>
						<span style={{ flex: '1 1 75px', cursor: 'pointer' }}>SMS</span>
						<span style={{ flex: '1 1 75px', cursor: 'pointer' }}>Call</span>
						<span style={{ flex: '1 1 75px', cursor: 'pointer' }}>Email</span>
					</div>
					<div className="dataFilters">
						<input style={{ maxWidth: '100px', flex: '1 1 10%' }} type="text" onChange={this.filter("firstName")} value={this.state.filterBy.firstName} />
						<input style={{ maxWidth: '100px', flex: '1 1 10%' }} type="text" onChange={this.filter("lastName")} value={this.state.filterBy.lastName} />
						<span style={{ flex: '0 0 25px' }} ></span>
						<input style={{ flex: '2 2 15%' }} type="text" onChange={this.filter("phoneNumber")} value={this.state.filterBy.phoneNumber} />
						<span style={{ flex: '0 0 25px' }} ></span>
						<input style={{ flex: '2 2 30%' }} type="text" onChange={this.filter("emailAddress")} value={this.state.filterBy.emailAddress} />
						<span style={{ flex: '3 3 225px' }} ></span>
					</div>
				</div>
			)

			//sort by date created for this table, oldest on bottom
			//var recipients = JSON.parse(JSON.stringify(this.props.data.GTFSSignUp.recipients.slice()));
			//var recipients = this.props.data.GTFSSignUp.recipients.slice()

			var recipients = []

			//convert object to array, make sure first name and last name are capitalized so it can be sorted
			for (let i in this.props.data.GTFSSignUp.recipients) {
				let item = this.props.data.GTFSSignUp.recipients[i]
				item.firstName = item.firstName[0].toUpperCase() + item.firstName.substring(1)
				item.lastName = item.lastName[0].toUpperCase() + item.lastName.substring(1)
				recipients.push(item)
			}

			recipients = recipients.slice();
			recipients.sort(this.sortFunc('lastName', 1))


			if (Object.keys(this.state.filterBy).length > 0) {
				recipients = this.filterFunc(recipients.slice(), this.state.filterBy)
			}

			if (this.state.sortBy !== '') {
				recipients.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}

			for (let i in recipients) {
				var recipient = recipients[i]
				contentMain.push(
					
					<div className="dataRow" key={recipient.SurveyID} onClick={this.showEditBox('GTFSSignUp', recipient)}>

						<span style={{ flex: '0 0 20%', textAlign: 'left'}}>{recipient.firstName} {recipient.lastName}</span>
						<span style={{ flex: '1 0 15%', textAlign: 'left'}}>{recipient.phoneNumber}</span>
						<span style={{ flex: '1 0 30%', textAlign: 'left'}}>{recipient.emailAddress}</span>
						<div className="activeBox">
							<div className={recipient.sms ? "enabled" : "disabled"}></div>
						</div>
						<div className="activeBox">
							<div className={recipient.call ? "enabled" : "disabled"}></div>
						</div>
						<div className="activeBox">
							<div className={recipient.email ? "enabled" : "disabled"}></div>
						</div>
						<span className="buttonBox" style={{ flex: '0 0 50px' }}>
							<img src={this.props.img.delete} alt="Delete Recipient" onClick={this.showDeleteBox('GTFSSignUp', recipient)} />
						</span>
					</div>
				)
			}

			if (this.state.editBox === 'GTFSSignUp') {
				
				contentEditBox.push(
					<div className="blackout" tabIndex="1" autoFocus >
						<div className="pop">

							<div className="viewCloser" onClick={this.cancel}></div>

							<div>You are editing alerts for: {this.state.selectedObject.firstName} {this.state.selectedObject.lastName}</div>
							<br />

							<div style={{ display: 'flex' }}>
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.firstName} onChange={this.editParam('firstName')} ></input>
									<span className="inputBar"></span><label className="textLabel">First Name</label>
								</div>
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.lastName} onChange={this.editParam('lastName')} ></input>
									<span className="inputBar"></span><label className="textLabel">Last Name</label>
								</div>
							</div>

							<div style={{ display: 'flex' }}>
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.phoneNumber} onChange={this.editParam('phoneNumber')} ></input>
									<span className="inputBar"></span><label className="textLabel">Phone Number</label>
								</div>
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.emailAddress} onChange={this.editParam('emailAddress')} ></input>
									<span className="inputBar"></span><label className="textLabel">Email Address</label>
								</div>
							</div>

							<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
								<div >
									<div>SMS</div>
									<div className="activeBox" onClick={this.toggle('sms')}>
										<div className={this.state.selectedObject.sms ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>
							<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
								<div >
									<div>Call</div>
									<div className="activeBox" onClick={this.toggle('call')}>
										<div className={this.state.selectedObject.call ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>
							<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
								<div >
									<div>Email</div>
									<div className="activeBox" onClick={this.toggle('email')}>
										<div className={this.state.selectedObject.email ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>

							<br /><hr></hr><br />
							<div>Select New Alerts</div>
							<br />

							<div>
								<div style={{ margin: '10px' }}>Route ID</div>
								<div style={{ display: 'flex' }}>
									<ReactSuperSelect style={{ flex: '1 0 150px', margin: '10px', display: 'inline-block' }} onChange={this.changedRouteId} placeholder={"Route ID"} clearable={false} closeOnSelectedOptionClick={false} dataSource={this.populateRouteIDs()} />
								</div>
							</div>
							<div>
								<div style={{ margin: '10px' }}>Stop ID</div>
								<div style={{ display: 'flex' }}>
									<ReactSuperSelect style={{ flex: '1 0 150px', margin: '10px', display: 'inline-block' }} onChange={this.changedStopId} placeholder={"Stop ID"} clearable={false} closeOnSelectedOptionClick={false} dataSource={this.state.stopIdList} clearSelectedValueOnDataSourceChange={true} disabled={this.state.stopIdList ? false : true}/>
								</div>
							</div>

							<div style={{ display: 'flex' }}>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Sun</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('sunday')}>
										<div className={this.state.configureStopper.selectedWeekdays.sunday ? "enabled" : "disabled"}></div>
									</div>
								</div>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Mon</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('monday')}>
										<div className={this.state.configureStopper.selectedWeekdays.monday ? "enabled" : "disabled"}></div>
									</div>
								</div>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Tue</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('tuesday')}>
										<div className={this.state.configureStopper.selectedWeekdays.tuesday ? "enabled" : "disabled"}></div>
									</div>
								</div>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Wed</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('wednesday')}>
										<div className={this.state.configureStopper.selectedWeekdays.wednesday ? "enabled" : "disabled"}></div>
									</div>
								</div>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Thu</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('thursday')}>
										<div className={this.state.configureStopper.selectedWeekdays.thursday ? "enabled" : "disabled"}></div>
									</div>
								</div>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Fri</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('friday')}>
										<div className={this.state.configureStopper.selectedWeekdays.friday ? "enabled" : "disabled"}></div>
									</div>
								</div>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Sat</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('saturday')}>
										<div className={this.state.configureStopper.selectedWeekdays.saturday ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>

							<div style={{ display: 'inline-block' }}>
								<div>Alert Hour:
								<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "H:i", enableTime: true, noCalendar:true }} value={'12:00'} onChange={date => {this.setState({ configureStopper: {...this.state.configureStopper, time: moment(date[0]).format('HH:mm').toString() }});console.log(this.state.configureStopper)}} />
								</div>
							</div>

							<div className="error" style={{ padding: '15px' }}>{this.state.errorAddScheduledAlert}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.addScheduledAlert(this.state.configureStopper)} >Add Scheduled Alert</div>}

							<br /><hr></hr><br />
							<div>Scheduled Alerts</div>
							<br />

							<div>
								<div className="dataHeaders">
									<span style={{ flex: '0 0 15%', cursor: 'pointer' }}>Route ID</span>
									<span style={{ flex: '1 0 15%', cursor: 'pointer' }}>Stop ID</span>
									<span style={{ flex: '1 0 25%', cursor: 'pointer' }}>Day</span>
									<span style={{ flex: '1 0 15%', cursor: 'pointer' }}>Time</span>
								</div>
							</div>

							{this.populateScheduledAlerts(this.state.selectedObject.stopper)}

							<br /><hr></hr><br />
							
							<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmChanges(this.state.selectedObject)} >Confirm</div>}

						</div>
					</div>
				)
			} else if (this.state.addBox === 'GTFSSignUp') {
				contentEditBox.push(
					<div className="blackout" tabIndex="1" autoFocus >
						<div className="pop">

							<div className="viewCloser" onClick={this.cancel}></div>

							<div>You are entering a new recipient.</div>
							<br />

							<div style={{ display: 'flex' }}>
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.firstName} onChange={this.editParam('firstName')} ></input>
									<span className="inputBar"></span><label className="textLabel">First Name</label>
								</div>
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.lastName} onChange={this.editParam('lastName')} ></input>
									<span className="inputBar"></span><label className="textLabel">Last Name</label>
								</div>
							</div>

							<div style={{ display: 'flex' }}>
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.phoneNumber} onChange={this.editParam('phoneNumber')} ></input>
									<span className="inputBar"></span><label className="textLabel">Phone Number</label>
								</div>
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.emailAddress} onChange={this.editParam('emailAddress')} ></input>
									<span className="inputBar"></span><label className="textLabel">Email Address</label>
								</div>
							</div>

							<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
								<div >
									<div>SMS</div>
									<div className="activeBox" onClick={this.toggle('sms')}>
										<div className={this.state.selectedObject.sms ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>
							<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
								<div >
									<div>Call</div>
									<div className="activeBox" onClick={this.toggle('call')}>
										<div className={this.state.selectedObject.call ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>
							<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
								<div >
									<div>Email</div>
									<div className="activeBox" onClick={this.toggle('email')}>
										<div className={this.state.selectedObject.email ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>

							<br /><hr></hr><br />
							<div>Select New Alerts</div>
							<br />

							<div>
								<div style={{ margin: '10px' }}>Route ID</div>
								<div style={{ display: 'flex' }}>
									<ReactSuperSelect style={{ flex: '1 0 150px', margin: '10px', display: 'inline-block' }} onChange={this.changedRouteId} placeholder={"Route ID"} clearable={false} closeOnSelectedOptionClick={false} dataSource={this.populateRouteIDs()} />
								</div>
							</div>
							<div>
								<div style={{ margin: '10px' }}>Stop ID</div>
								<div style={{ display: 'flex' }}>
									<ReactSuperSelect style={{ flex: '1 0 150px', margin: '10px', display: 'inline-block' }} onChange={this.changedStopId} placeholder={"Stop ID"} clearable={false} closeOnSelectedOptionClick={false} dataSource={this.state.stopIdList} clearSelectedValueOnDataSourceChange={true} disabled={this.state.stopIdList ? false : true}/>
								</div>
							</div>

							<div style={{ display: 'flex' }}>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Sun</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('sunday')}>
										<div className={this.state.configureStopper.selectedWeekdays.sunday ? "enabled" : "disabled"}></div>
									</div>
								</div>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Mon</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('monday')}>
										<div className={this.state.configureStopper.selectedWeekdays.monday ? "enabled" : "disabled"}></div>
									</div>
								</div>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Tue</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('tuesday')}>
										<div className={this.state.configureStopper.selectedWeekdays.tuesday ? "enabled" : "disabled"}></div>
									</div>
								</div>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Wed</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('wednesday')}>
										<div className={this.state.configureStopper.selectedWeekdays.wednesday ? "enabled" : "disabled"}></div>
									</div>
								</div>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Thu</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('thursday')}>
										<div className={this.state.configureStopper.selectedWeekdays.thursday ? "enabled" : "disabled"}></div>
									</div>
								</div>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Fri</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('friday')}>
										<div className={this.state.configureStopper.selectedWeekdays.friday ? "enabled" : "disabled"}></div>
									</div>
								</div>
								<div style={{ paddingTop: '25px', display: 'inline-block', justifyContent: 'space-around'}}>
									<div>Sat</div>
									<div className="activeBox" onClick={this.toggleWeekdaySelection('saturday')}>
										<div className={this.state.configureStopper.selectedWeekdays.saturday ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>

							<div style={{ display: 'inline-block' }}>
								<div>Alert Hour:
								<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "H:00", enableTime: true, noCalendar:true }} value={'12:00'} onChange={date => {this.setState({ configureStopper: {...this.state.configureStopper, time: moment(date[0]).format('HH:00').toString() }});console.log(this.state.configureStopper)}} />
								</div>
							</div>

							<div className="error" style={{ padding: '15px' }}>{this.state.errorAddScheduledAlert}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.addScheduledAlert(this.state.configureStopper)} >Add Scheduled Alert</div>}

							<br /><hr></hr><br />
							<div>Scheduled Alerts</div>
							<br />

							<div>
								<div className="dataHeaders">
									<span style={{ flex: '0 0 15%', cursor: 'pointer' }}>Route ID</span>
									<span style={{ flex: '1 0 15%', cursor: 'pointer' }}>Stop ID</span>
									<span style={{ flex: '1 0 25%', cursor: 'pointer' }}>Day</span>
									<span style={{ flex: '1 0 15%', cursor: 'pointer' }}>Time</span>
								</div>
							</div>

							{this.populateScheduledAlerts(this.state.selectedObject.stopper)}

							<br /><hr></hr><br />
							
							<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmChanges(this.state.selectedObject)} >Confirm</div>}


						</div>
					</div>
				)
			} else if (this.state.deleteBox == 'GTFSSignUp') {
				
				contentEditBox.push (
					<div className="blackout" tabIndex="1" autoFocus>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>
							<div style={{ textAlign: 'center' }}>You are removing this recipient:</div>
							<div style={{ textAlign: 'center' }}>{this.state.selectedObject.firstName} {this.state.selectedObject.lastName}</div>
							<br />

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmDelete('GTFSRecipient', this.state.selectedObject)}>Delete Recipient</div>}
						</div>
					</div>
				)
				
			}
			
			return (
				<div className="viewContent" id="reportView" >
					<div style={{ overflow: 'auto', height: 'calc(100% - 45px)' }}>
						{contentMain}
					</div>
					{contentEditBox}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

const icon = "menuHelp"
const roles = ["View"]
export { GTFSSignUp, icon, roles }
